module.exports = __webpack_public_path__ + "img/booth.9c907ec3.jpg";